var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cleave',_vm._b({staticClass:"form-control",attrs:{"options":_vm.options},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'cleave',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }